import type { OpenSnackbarOptions } from '@patrianna/shared-patrianna-types/store/SnackbarModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { SnackbarState } from './types'

const initialState: SnackbarState = {
  visible: false,
  message: '',
  action: null,
  autoHide: null,
  messageAlign: null,
  isFullScreen: false,
}

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    openSnackbar: (state, action: PayloadAction<OpenSnackbarOptions & { isFullScreen?: boolean }>) => {
      const defaultOptions: OpenSnackbarOptions = {
        message: '',
        autoHide: null,
        variant: 'error',
        messageAlign: 'space-between',
        positionVertical: 'bottom',
        positionHorizontal: 'center',
      }

      return {
        ...defaultOptions,
        ...action.payload,
        visible: true,
        isFullScreen: action.payload.isFullScreen || false,
      }
    },

    closeSnackbar: (state) => {
      state.visible = false
    },
    clearSnackbarState: () => initialState,
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof snackbarSlice.actions>>
export const { actions } = snackbarSlice
